// extracted by mini-css-extract-plugin
module.exports = {"list-item-submission-failed":"OrderLinkListCard_list-item-submission-failed__qD6oq"};